/**
 * @author Rejo Varghese
 * @description Demand days table
 */
import React from 'react';
import { Table } from 'antd';
import { getDemandDaysColumns } from './demand-days-table.module';
import { isValidArray } from '../../../utils/utilities';

const DemandDaysTable = (props) => {

    const {
        data,
        onEdit
    } = props;
    
    return (
        <div>
                <Table
                    dataSource = {isValidArray(data)?data:[]}
                    columns = {getDemandDaysColumns(onEdit)}
                    rowKey={record => record.id}
                />
        </div>
    )
}

export default DemandDaysTable;